module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container mt-3"
  }, [_c('b-card', {
    staticClass: "text-center"
  }, [_c('b-row', {
    staticClass: "treasury-logo p-1",
    attrs: {
      "align-v": "end"
    }
  }, [_c('b-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('img', {
    staticClass: "p-1",
    attrs: {
      "src": require("@/assets/images/grb.svg")
    }
  })]), _vm._v(" "), _c('b-col', [_c('div', {
    staticClass: "p-2"
  }, [_c('label', [_vm._v("РЕПУБЛИКА СРБИЈА")]), _vm._v(" "), _c('label', [_vm._v("МИНИСТАРСТВО ФИНАНСИЈА")]), _vm._v(" "), _c('label', {
    staticStyle: {
      "font-weight": "800"
    }
  }, [_vm._v("УПРАВА ЗА ТРЕЗОР")])])])], 1), _vm._v(" "), _c('b-row', {
    staticStyle: {
      "height": "35px"
    }
  }), _vm._v(" "), _c('b-card', {
    staticClass: "text-center",
    attrs: {
      "bg-variant": "danger",
      "text-variant": "white"
    }
  }, [_c('p', {
    staticClass: "card-text"
  }, [_vm._v(_vm._s(_vm.$t('notFound')))])]), _vm._v(" "), _c('b-row', {
    staticStyle: {
      "height": "50px"
    }
  }), _vm._v(" "), _c('b-row', {
    staticClass: "mt-3",
    attrs: {
      "align-h": "center"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.changelogPath
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('general.changelog')))])])]), _vm._v(" "), _c('b-row', {
    staticClass: "mt-5",
    attrs: {
      "align-h": "center"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.supportPath
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('general.technicalSupport')))])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-500c6df4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","b-img":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NotFoundPage.vue
// module id = 764
// module chunks = 1